import { render, staticRenderFns } from "./EditClientCPAssessment.vue?vue&type=template&id=73399e96&"
import script from "./EditClientCPAssessment.vue?vue&type=script&lang=js&"
export * from "./EditClientCPAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports